import { Banner, Button, Icon, Layout, LegacyStack, LegacyCard, Page } from "@shopify/polaris";
import { ExternalMinor } from "@shopify/polaris-icons";
import React from "react";
import styled from "styled-components";

import { List, links } from "./constants";
import { ContactSupportBlock } from "./ContactSupportBlock";
import { CSMBlock } from "./CSMBlock";

import { useSmartrrVendorSelector } from "@vendor-app/app/_state/typedVendorReduxHooks";

const linkSettings = { target: "_blank", rel: "noopenere noreferrer" };

const PageWrapper = styled.div`
  > .Polaris-Page {
    max-width: max(64rem, 75%);
    padding: 0 16px;

    & .Polaris-Layout__Section:not(:nth-child(1)) .Polaris-LegacyCard,
    & .Polaris-Layout__Section:not(:nth-child(1)) {
      max-width: 518px;
      min-width: 518px !important; //To override default Polaris styles
    }
    & .Polaris-Layout__Section:not(:nth-child(1)) {
      margin-left: 20px;
    }
    .Polaris-Page-Header__PrimaryActionWrapper a.Polaris-Button:hover {
      text-decoration: none;
    }
    & .external-btn {
      margin-top: 2rem;
    }
    & .external-btn a.Polaris-Button:hover {
      text-decoration: none;
    }
    & .faq-link {
      text-decoration: underline;
      line-height: 18px;
    }
    & .faq-link:hover {
      color: var(--p-color-text-interactive-hover);
    }
  }
`;

export function AdminSupportRoute(): JSX.Element {
  const [showBanner, setShowBanner] = React.useState(
    JSON.parse(localStorage.getItem("banner-is-open") || "{}") || false
  );

  const dismissBanner = () => {
    localStorage.setItem("banner-is-open", JSON.stringify(!showBanner));
    setShowBanner(!showBanner);
  };

  const activePlan = useSmartrrVendorSelector(state => state.accountPlans.activePlan);

  return (
    <PageWrapper>
      <Page title="Help">
        <Layout>
          <Layout.Section fullWidth>
            {!!showBanner && (
              <Banner
                onDismiss={() => {
                  dismissBanner();
                }}
              >
                <p>
                  Need help? Think of this page as your Smartrr concierge. You&apos;ll find answers to common
                  questions here. If you don&apos;t, please reach out to us with your questions or feature
                  requests. Letting us know what&apos;s important to you doesn&apos;t just help improve our core
                  product—it helps us better serve other Shopify stores as well.
                </p>
              </Banner>
            )}
          </Layout.Section>

          <Layout.Section>
            <LegacyCard sectioned title="Top 10 FAQs">
              <List>
                {links.map(({ text, link }) => (
                  <li key={link}>
                    <a className="faq-link" href={link} {...linkSettings}>
                      {text}
                    </a>
                  </li>
                ))}
              </List>
              <div className="external-btn">
                <Button
                  icon={<Icon source={ExternalMinor} color="base" />}
                  url="https://help.smartrr.com/docs/"
                  external
                >
                  All help docs
                </Button>
              </div>
            </LegacyCard>
          </Layout.Section>

          <Layout.Section>
            <LegacyStack>
              <ContactSupportBlock />

              <CSMBlock />

              {activePlan?.planName === "Excel" && <CSMBlock />}
            </LegacyStack>
          </Layout.Section>
        </Layout>
      </Page>
    </PageWrapper>
  );
}
